<template>
    <div class="prepare_medicine">
        <div class="configm_head">
            <img  @click="logo_click" class="configm_headlogo pc" src="../assets/img/configm_logo.png" alt="">
            <img
                 src="../assets/img/logo.svg"
                 class="configm_headlogo mobile"
                 @click="logo_click"
             />
            <div class="configm_languagemember">
                 <div class="configm_language pc">
                     <!-- <div class="configm_language_item"  @click="changeLanguage('zh')">Chinese</div>
                     <div class="configm_language_item"  @click="changeLanguage('en')">English</div>
                     <div class="configm_language_item"  @click="changeLanguage('jp')">Japanese</div> -->
                     <ul class="ignore switch">
                        <!-- <li><a href="javascript:translate.changeLanguage('chinese_simplified');" :style="[{ 'font-weight': activeLanguage == 'chinese_simplified' ? 'bold' : '' }]">CN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('english');" :style="[{ 'font-weight': activeLanguage == 'english' ? 'bold' : '' }]">EN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('japanese');" :style="[{ 'font-weight': activeLanguage == 'japanese' ? 'bold' : '' }]">JP</a></li> -->
                        
                        <li><a href="javascript:translate.changeLanguage('chinese_simplified');">CN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('english');">EN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('japanese');">JP</a></li>
                    </ul>
                 </div>
                 <div class="configm_language mobile">
                     <!-- <div class="configm_language_item"  @click="changeLanguage('zh')">CN</div>
                     <div class="configm_language_item"  @click="changeLanguage('en')">EN</div>
                     <div class="configm_language_item"  @click="changeLanguage('jp')">JP</div> -->
                     <ul class="ignore switch">
                        <!-- <li><a href="javascript:translate.changeLanguage('chinese_simplified');" :style="[{ 'font-weight': activeLanguage == 'chinese_simplified' ? 'bold' : '' }]">CN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('english');" :style="[{ 'font-weight': activeLanguage == 'english' ? 'bold' : '' }]">EN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('japanese');" :style="[{ 'font-weight': activeLanguage == 'japanese' ? 'bold' : '' }]">JP</a></li> -->
                        
                        <li><a href="javascript:translate.changeLanguage('chinese_simplified');">CN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('english');">EN</a></li>|
                        <li><a href="javascript:translate.changeLanguage('japanese');">JP</a></li>
                    </ul>
                 </div>
                 <div class="configm_member" @click="tomember">个人中心</div>
             </div>
        </div>
        <div class="history">
            <img class="history_img" src="../assets/img/history_top.png" alt="">
             <div class="history_top">
                <div class="history_tit">日本家庭配置药的故事</div>
                <div class="history_titen">The story of Japanese home medicine preparation</div>
                <div class="history_titdes">持续200年以上历史</div>
                <div class="history_titdes">日本家庭配置药至今的百年历史。</div>
                <div class="history_titdes">CGM制药如何创造新模式？</div>
                <div class="history_titdes">如何延续下去？</div>
                <div class="history_titdes">服务全世界的家庭创造新时代用药？</div>
                <div class="history_feature clearfix">
                    <div class="history_featuretit">Chapters</div>
                    <div class="history_featurebox">
                        <div class="history_featureitem">保护日本古代医学法</div>
                        <div class="history_featureitem">支持人民健康的「健康意识」</div>
                        <div class="history_featureitem">起因是江户城腹痛事件</div>
                        <div class="history_featureitem">面向全国普及</div>
                        <div class="history_featureitem">先用后付</div>
                        <div class="history_featureitem">药事法制定</div>
                        <div class="history_featureitem">CGM制药普及全世界</div>
                    </div>
                </div>
             </div>
             <div class="history_cont">
                <!-- <div class="history_line"></div> -->
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history1.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt">保护日本 <br/> 古代医学法</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                        <img class="history_twoimg" src="../assets/img/history2.png" alt="">
                        <img class="history_twoimgs" src="../assets/img/history4.png" alt="">
                    </div>
                    <div class="history_right history_twobox">
                        <div class="history_twotxt">平城天皇在大同三年（808年）勅令编纂的《大同類聚方》是一部勅选书。这是因为平城天皇担心我国自古以来的药法因佛教和随之传入的中医的兴盛而可能衰微，故命安部真直、出云广贞等人记载日本古代药物的优点，目的是复兴日本古代的好药，该书共分前百卷。</div>
                         <img class="history_rightimg" src="../assets/img/history3.png" alt="">
                         <div class="history_twotxt center">第一卷至第十三卷为用药部分，记录了植物药279种（包括山草、野草、树木、谷物等），矿物药36种，生物药79种。第十四卷至第百卷为处方部分，记载了百余种疾病名称，根据症状给出处方，这些处方既有自太古以来民间创制、秘传数百年的，也有从新罗、百济、高句丽等地新引进的。其中许多处方采用了与佛教一同传入的中医方剂。</div>
                         <div class="history_twotxt">例如，作为日本特有的药材，有“千振（当药）”，这是中国没有的植物，因此不出现在中医药典中。但是，《大同類聚方》中多次提到了千振。这证明了千振自古以来作为日本的民间药非常有效。也可能被用作龙胆等苦味健胃、消化、整肠药的替代品。</div>
                    </div>
                </div>
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history5.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt history_health">支持人民健康的「健康意识」</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                        <img class="history_threeimg" src="../assets/img/history6.png" alt="">
                    </div>
                    <div class="history_right history_threebox">
                        <div class="history_twotxt">从古代开始，豪族及其氏神神社珍视一族的健康和领地领民的保护，寻求良好的医药，并将这些作为一族的“家药”分给领民，通过让部族成员都变得健康强大，促进了一族的发展扩大。随着佛教和中医药学知识的传入，为了聚集民众的信仰，用佛教的教义解救心灵的迷惘，用新传入的中医药学知识和药物来救治疾病等，救助了领民等。像东大寺制作救命丸，西大寺制作豊心丹一样，大多数著名的寺院都制作并施药。奈良县葛城市的当麻寺至今仍可见其痕迹，作为役行者源流的寺庙，有售卖陀罗尼助的御坊。</div>
                         <img class="history_threerimg" src="../assets/img/history7.png" alt="">
                         <div class="history_twotxt">作为施药，推古天皇十九年（611年）5月5日，推古天皇带领百官到大和国宇陀郡采集药草，延喜式记载了大量从大和献上的药种。佛教传入后，随着与隋唐的交流开始，医学和药物被传入，仿照唐的制度制定了医药制度。大和的许多神社、佛寺从施药开始，大峰的药草后来在京都的公卿中珍贵，大和的诸寺神社的药引起了注意，修验者等也承担了将其传遍全国的角色。</div>
                         <img class="history_threecimg" src="../assets/img/history8.png" alt="">
                         <div class="history_twotxt">随着时间的推移，到了中世纪时，寺院神社门前的民间人也开始制药。室町时代大永五年（1525年），姫路的广峰大明神神主井口太夫得知后，黒田孝高（如水）的祖父黒田重隆推出了黑田家传的眼药配方“玲珠膏”（れいしゅこう），赚了大钱，通过放贷业成为備前福岡的有力豪族，并能够为御着城主小寺政职效力。1455年中原康富的《康富记》中，1453年5月2日（6月17日）的条目记载了“諸薬商買の千駄匱申し間事談合とするなり。薬売るもの施薬院相計る所なり。”，又，“御府文书”记载了1460年京都四府賀兴丁座中有经营药品类商品的商人。全国的药品行商不仅仅是走街串巷的卖，还在各地区的寺、神社、家中批发或委托销售或施药，各种商人带着药品四处推销、宣传的机会也越来越多。</div>
                    </div>
                </div>
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history9.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt history_health">起因是江户城腹痛事件</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                    </div>
                    <div class="history_right history_twobox">
                        <div class="history_twotxt">1690年，在江户城内，三春城主秋田輝季因腹痛，富山藩主前田正甫给他服用了合药富山反魂丹（汉贡丹），秋田輝季的腹痛惊人地恢复了，这一事件被称为江户城腹痛事件。这件事让各国大名惊讶，他们请求富山的药商行销，使富山的卖药变得有名，并且奠定了以“先用后利”为基础的现代医药品配置销售业的基础。在安静7年（1860年）2月，制定了一份名为“国中组合取极连印帐”的同伴规约，为了符合幕府的方针，变为“南都药种取締所”指导下的业态，为了维持和发展商业秩序，由米田丈助等77名业者创建。此外，在慶应2年（1866年）7月，72名大和的业者与越中国富山的总代3名、加贺领总代2名之间进行了协商，制定了一份包含15条的议定取締书。</div>
                    </div>
                </div>
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history10.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt history_oneline">面向全国普及</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                        <img class="history_fourimg1" src="../assets/img/history11.png" alt="">
                        <img class="history_fourimg2" src="../assets/img/history12.png" alt="">
                        <img class="history_fourimg3" src="../assets/img/history14.png" alt="">
                    </div>
                    <div class="history_right history_threebox">
                        <div class="history_twotxt">《组合取极连印帐》的要点包括： </div>
                        <div class="history_twotxt">遵守公家的指示，不违反南都药种取締所的规定。</div>
                        <div class="history_twotxt">药材的买卖应按照规定的价格进行，不得进行不正当交易。</div>
                        <div class="history_twotxt">由于药材的重量不一，应按照京大阪的定法调整，一斤定为二百匕。</div>
                        <div class="history_twotxt">近年来人参等药材出现了许多假货，这关系到人命安全，发现后应立即向年行司总代报告。</div>
                        <div class="history_twotxt">不得向他国的医家销售药材，也不得从他国购入后销售给医家等。</div>
                        <div class="history_twotxt">应直接从产地购入药材股份或合药股份，不得向他国出货等。</div>
                        <div class="history_twotxt">不得利用组合以外的人员收集和药材。</div>
                        <div class="history_twotxt">合药组合成员除了销售药品外，还经营染料、绘画工具、香具、糖等，但不得因此而影响组合成员。</div>
                        <div class="history_twotxt">合药组合成员应避免销售相同品牌或容易混淆的药品，不得诋毁其他药品或进行价格竞争。</div>
                        <div class="history_twotxt">奉公结束或年季满的人应与前主人协商后再雇用。如果发现奉公人因误会带走了物品，应通知其主人。</div>
                        <div class="history_twotxt">接收药材牌后，应向行司报告，并向年行司支付两两的组合行为费。</div>
                        <div class="history_twotxt">若有药材销售款项未支付的情况，应通知组合成员，并在账款结清前相互停止交易。</div>
                        <div class="history_twotxt">作为年行司费用，药材店需支付五分银，和汉店、合药店支付二分五厘。</div>
                        <div class="history_twotxt">所有成员均同意上述条款，并承诺遵守交易规则，对于行为不端的成员，将向取締所报告，并从组合中除名，对此无异议，所有成员共同在协定书上连印。</div>
                        <div class="history_twotxt">安政7年2月，葛上郡今住村：</div>
                        <div class="history_twotxt mtb">大和与富山业者的议定书《议定取締书》</div>
                        <div class="history_twotxt">包括以下要点：</div>
                        <div class="history_twotxt">近年来，药材、纸张、米、运输费、住宿费等成本上涨，因此药品价格上调三成。</div>
                        <div class="history_twotxt">决不处理不正当药材、有毒的药品。</div>
                        <div class="history_twotxt">即使是同一品牌的药品，也不改变文字或笔法造成混淆。</div>
                        <div class="history_twotxt">药品是救治人类疾苦的，应当谨慎调配。</div>
                        <div class="history_twotxt">避免降价销售和诋毁他人。如发现有误解的人，应提供确凿证据进行申报。</div>
                        <div class="history_twotxt">禁止向已有的客户提供降价销售。</div>
                         <img class="history_fourimg4" src="../assets/img/history13.png" alt="">
                         <div class="history_twotxt">当药品堆放在一起时，不得贬低他人的药品自吹自擂。</div>
                         <div class="history_twotxt">停止奉公的人或得到休假的奉公人，应事先通知原雇主后再雇用。</div>
                         <div class="history_twotxt">规定奉公人的工资，高级为每年五百匕，中级为三百五十匕，低级为二百匕。</div>
                         <div class="history_twotxt">绝不拾起他人的空药袋，换上自己名字的药袋。</div>
                         <div class="history_twotxt">在旅途中沉迷于酒色、赌博的人，应予以劝告，不听者将其行李名单没收并送回国内。</div>
                         <div class="history_twotxt">若在宿处发生急死、急病等情况，附近的人应立即赶到并提供帮助。</div>
                         <div class="history_twotxt">在定宿原则上同住一室。</div>
                         <div class="history_twotxt">一旦制定了上述同伴规定，每年至少参加一次会议，未参加者也应一视同仁地承担费用。若出国（藩）心存误解并违反任何一条约定，应向取締所报告并受到管制，相关费用由违法者赔偿。</div>
                         <div class="history_twotxt">所有同伴共同制定议定书并连印。</div>
                         <div class="history_twotxt">慶应2年7月29日</div>
                         <div class="history_twotxt">以下七十七名签名盖章</div>
                         <div class="history_twotxt">大和的72名签名盖章者均为在国（藩）</div>
                         <div class="history_twotxt">外从事配置销售药品的业者。富山、加贺领（指越中国的加贺藩领）的5人均为越中销售药品的代表，特意召集进行协商。至此，江户时代末期，富山、奈良、滋贀、佐贺、岡山等地的药品销售业已经相当发展，并形成了全国性的行业。</div>
                    </div>
                </div>
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history15.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt">先用后付</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                        <img class="history_fiveimg3" src="../assets/img/history18.png" alt="">
                    </div>
                    <div class="history_right history_threebox">
                        <div class="history_twotxt">“先用后利”这一概念起源于药品销售，是富山卖药业的基本理念，意为“先使用，后获利”。这一理念从江户元禄时期的创业时代一直传承至今。富山藩第二代藩主前田正甫公对卖药的指示是：“先考虑用途，后考虑利益，将医疗的仁爱扩展至偏远贫穷的村落，贯彻救治的志向。”这传达了一种理念，即在当时已经遍布全国的药品市场中，作为藩的新事业介入市场，必须拥有与现有卖药不同的新销售策略。</div>
                        <div class="history_fiveimgbox">
                            <img class="history_fiveimg1" src="../assets/img/history16.png" alt="">
                            <img class="history_fiveimg2" src="../assets/img/history17.png" alt="">
                        </div>
                         <div class="history_twotxt fivebt">当时，经过约200年的战国动乱后，江户幕府及全国各藩都致力于救国济民，特别是注重领民的健康保持。然而，疫病频发，医药品供应不足。尽管从室町时代起就有卖药的存在，但店铺销售不多，多数经营药品的商人是四处宣扬夸大药效的街头商贩。此外，在地方普通民众的日常生活中，货币流通不充分，对于货币积累较少的民众而言，家中常备药品是罕见的，必须根据需要从商人那里购买。</div>
                         <div class="history_twotxt">在这样的社会背景下，预先将医药品存放在民众手边，需要时使用，药品费用稍后支付的“先用后利”方式，作为一种创新服务系统，符合时代背景，引发了需求。最初是存放在各地区的组织负责人或寺庙等处，逐渐转为存放在普通家庭中。江户时代的配置销售业者不仅仅处理药品，还将访问地的产品介绍给其他地区，反之亦然，主要业务之一是提供各地的情况和信息。例如，富山的卖药业者被允许进入萨摩藩，这一经历是个很好的例子。当时的卖药业者，存在着像现代综合商社那样经营大规模业务的商人。</div>
                    </div>
                </div>
                <div class="history_one">
                    <div class="history_left">
                        <img class="history_oneimg" src="../assets/img/history19.png"  alt="">
                    </div>
                    <div class="history_right history_onebox">
                        <div class="history_onetxt">药事法制定</div>
                    </div>
                </div>
                <div class="history_two">
                    <div class="history_left">
                        <img class="history_siximg3" src="../assets/img/history20.png" alt="">
                    </div>
                    <div class="history_right history_sixbox">
                        <div class="history_twotxt">进入明治时代后，西洋医学成为主流，长期以来在我国培育的中医药学因国家政策被否定和废止，卖药业也面临了极大的困境。大约从1886年开始尝试药品出口，从明治末期到大正时期，出口卖药业务大幅增长，与中国、美国、印度等多个国家有了交流。到了大正时代初期达到高峰，当时活跃的中国市场中有80%被出口卖药所占据。</div>
                         <img class="history_siximg1" src="../assets/img/history21.png" alt="">
                         <div class="history_twotxt">这一变化促使药材商向大规模制药厂商转变，生产符合西洋医学的医药品，向医生和销售商批发，以及开设店铺向普通民众销售，从行商形式大幅转移。进入20世纪后，有关卖药的制度和法律相继建立，1914年实施了规定卖药调整和销售资格及责任的“卖药法”，1943年为了保证药品质量，制定了将医药品制造全部转为许可制的“薬事法”。</div>
                    </div>
                </div>
             </div>
             <div class="history_world">CGM制药普及全世界</div>
        </div>
        <div class="configm_footer">
             <div class="configm_footertop">
                 <div class="configm_footleft">
                     <img src="../assets/img/configm_logo.png" alt="">
                 </div>
                 <div class="configm_footrigth">
                     <div class="configm_footrtext">用药时请先阅读说明书</div>
                     <div class="configm_footrtext">不明症状请立即在私人家庭微信群询问客服人员</div>
                     <div class="configm_footrtext">每个微信群都有制药相关人员以及医生、任何家庭症状以外的问题也会提供回答</div>
                     <div class="configm_footrtext">人工制药服药指导以外、也可以回答您的生活问题、它是由Chat GPT为您提供服务</div>
                 </div>
             </div>
             <div class="configm_footerbot">
                 <div class="configm_footerbotl">© 2024 CGM GROUP, Inc.</div>
                 <div class="configm_footerbotr">CGM公司｜CGM Medical线上处方平台｜ 关于个人信息保护</div>
             </div>
        </div>
    </div>
   </template>
   <script>
   import { medical_href } from "../assets/config/img";
   import Clickoutside from "element-ui/src/utils/clickoutside";
   import { mapState, mapMutations } from "vuex";
   import { Toast } from "vant";
   export default {
     directives: { Clickoutside },
     computed: {
       ...mapState(["cgmUserVO","mobile"]),
     },
     data() {
       return {
         configFlag: null,
         package_list: [],
         mouthItem:1,
         spu_list: [],
         medicinelist: [],
         titself:false,
         isStyled:false,
         stickyChange:"position:relative;z-index:0",
         total_money:0,
         sum:0,
         cart: [],
         cartdetail: [],
         membername:'',
         sex:'',
         settlement:true,
         elementWidth:50+'px'
       };
     },
     mounted() {
        this.list();
       this.getAddress();
     },
    //  watch(){
    //     console.log(this.activeLanguage)
    //  },
     methods: {
         //数量加减
         append_change() {
             let list = this.medicinelist;
             let count = 0;
             let sum = 0;
             let cart = [];
             let cartdetail = [];
             for (let i in list) {
                 for (let j in list[i].cgmSpuList) {
                     count += list[i].cgmSpuList[j].rmbAmount * list[i].cgmSpuList[j].appendNum;
                     sum += list[i].cgmSpuList[j].appendNum;
                     if(list[i].cgmSpuList[j].appendNum>0){
                         cartdetail.push(list[i].cgmSpuList[j])
                         cart.push({ name: list[i].cgmSpuList[j].spuName,
                                     price: list[i].cgmSpuList[j].rmbAmount,
                                     num: list[i].cgmSpuList[j].appendNum});
                     }
                   
                 }
             }
             console.log()
             this.total_money = count;
             this.sum = sum;
             this.cart = cart;
             this.cartdetail = cartdetail;
             sessionStorage.setItem("nowcart",JSON.stringify(cartdetail))
             
         },
         // 用户信息membername
         getAddress(){
             let userId = JSON.parse(this.cgmUserVO).userId;
             this.axios
             .get("/cgmUser/getUserById", {
                 params: {
                 userId,
                 },
             })
             .then((res) => {
                 if (res.data.code == 200) {
                 this.userVO = res.data.data;
                 this.membername = res.data.data.cgmFamily.firstName+ res.data.data.cgmFamily.lastName
                 if(res.data.data.cgmFamily.sex == '女'){
                     this.sex = "女士"
                 }else{
                     this.sex = "先生"
                 }
                
                 }
             });
         },
         gobuy(){
             if (this.cgmUserVO) {
                 if (this.sum < 3) {
                     Toast.fail("请补充三盒以上");
                     return;
                 }else{
                     this.$router.push({
                         path: "/Pay",
                         query: {
                             packageId:"1731336393415692289",
                             total:this.total_money,
                             sum:this.sum
                         },
                     });
                 }
                
             } else {
                 this.$router.push({ path: "/login" });
                 this.$message({ type: "error", message: "请登录" });
             }
         },
             
         check_click(spuId) {
             this.$router.push({
                 path: "/spuDetail",
                 query: {
                 spuId,
                 },
             });
         },
         list(){
             this.axios
             .get("/cgmCategory/list ")
             .then((res) => {
             if (res.data.code == 200) {
                 console.log(res.data.data)
                 this.medicinelist = res.data.data
                 // this.cgmSpuList = res.data.data.cgmSpuList
             }
             });
         },
         cgmPackageList() {
         this.axios
             .get("/cgmPackage/list", {
             params: {},
             })
             .then((res) => {
             if (res.data.code == 200) {
                 this.package_list = res.data.data;
             }
             });
         },
       logo_click() {
         if (this.cgmUserVO) {
               let userId = JSON.parse(this.cgmUserVO).userId;
               this.axios
                 .get("/cgmOrder/getOrderCount", {
                   params: {
                     userId,
                   },
                 })
                 .then((res) => {
                   if (res.data.code == 200) {
                     this.configFlag = res.data.data;
                     if(res.data.data > 0){
                       this.$router.push("/ConfigMedicine");
                     }else{
                       this.$router.push("/Firstindex");
                     }
                   }
                 });
               }
       },
       tomember() {
         if (this.mobile) {
             // this.navigationDialogVisible = true;
             console.log(this.mobile)
             this.$router.push({
             path: "/menu",
             });
         } else {
             this.setLeftItem(1);
             this.$router.push({
             path: "/userCenter",
             });
         }
       },
       showsettle() {
         this.elementWidth = "80%"
         // setTimeout(() => {
         //     this.elementWidth = "80%" 
         // }, 2000);
         this.settlement = false
       },
       
       handleClose() {
         this.elementWidth = 50 + "px" 
         // setTimeout(() => {
         //     this.elementWidth = 50 + "px" 
         // }, 2000);
         this.settlement = true
     },
       handleChange(val) {
         console.log(val);
       },
       medical_click() {
         window.open(medical_href);
       },
     },
     destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
     },
   };
   </script>
   <style lang="scss" scoped>
     //    头部
     .configm_head{
         height: 127px;
         // display: flex;
         // justify-content: space-between;
         // align-items: center;
         padding-left: 54px;
         position: relative;
         z-index: 100;
         background: #fff;
     }
     .configm_headlogo{
         width: 335px;
         position: absolute;
         top:40px;
     }
     .configm_languagemember{
         position: absolute;
         top:50px;
         right:93px;
         font-size: 0;
     }
     .configm_language{
         margin-right: 96px;
         font-size: 0;
         display: inline-block;
     }
     .configm_language_item{
         display: inline-block;
         cursor: pointer;
         font-size: 16px;
         font-weight: bold;
         position: relative;
     }
     .configm_language_item:not(:last-child){
         margin-right: 16px;
     }
     .configm_language_item:not(:last-child)::after{
         content:'';
         position: absolute;
         right:-8px;
         top:0px;
         width: 1px;
         height: 18px;
         background: #000;
     }
     .configm_member{
         display: inline-block;
         width: 70px;
         font-weight: bold;
         font-size: 16px;
         cursor: pointer;
     }
    .prepare_medicine:lang(en) .configm_member{
       width: auto;
     }
     .prepare_medicine:lang(jp) .configm_member{
        width: auto;
     }
     // 底部
     .configm_footer{
         padding:37px 0 80px;
         box-sizing: border-box;
         background: #fff;
         border-top:3px solid #1161BA;
     }
     .configm_footertop{
         overflow: auto;
         zoom: 1;
         padding:0 127px 25px 60px;
     }
     .configm_footleft{
         float: left;
     }
     .configm_footrigth{
         float: right;
         text-align: right;
     }
     .configm_footleft img{
        width: 335px;
        display: block;
        margin-top: 60px;
     }
     .configm_footrtext{
         font-size: 16px;
         margin-bottom: 25px;
     }
     .configm_footerbot{
         overflow: auto;
         zoom: 1;
         border-top: 1px solid #F2F2F2;
         font-size: 16px;
         color:rgba(0,0,0,.56);
         padding:25px 127px 0 60px;
     }
     .configm_footerbotl{
         float: left;
     }
     .configm_footerbotr{
         float: right;
     }
     .mobile{
        display: none;
     }
    //  历史内容
    .prepare_medicine{
        background: #FFD9B7;
    }
    .history_img{
        width: 100%;
        // background: #fff;
    }
    .history_top{
        width: 100%;
        box-sizing: border-box;
        padding:80px 40px 40px;
    }
    .history_tit{
        font-size: 105px;
        font-weight: bold;
        color:#303030;
        margin-bottom: 90px;
        text-align: center;
        line-height: 80px;
    }
    .history_titen{
        width: 900px;
        font-size: 50px;
        font-weight: bold;
        color:#A5432E;
        text-align: right;
        margin-bottom: 30px;
        margin-left: auto;
        height: 116px;
    }
    .history_titdes{
        text-align: right;
        font-size: 25px;
        line-height: 40px;
    }
    .history_feature{
        margin-top: 96px;
        padding:0 0 0 23px;
    }
    .clearfix{
        *zoom:1
    }
    .clearfix::after{
        display:block;
         content:"clear"; 
         height:0; 
         clear:both; 
         overflow:hidden;
         visibility:hidden;
    }
    .history_featuretit{
        float: left;
        position: relative;
        font-size: 30px;
        color: #731D0B;
        margin-right: 80px;
    }
    .history_featuretit::after{
        position: absolute;
        content: "";
        left:-23px;
        bottom:-40px;
        width: 219px;
        height: 6px;
        background: #731D0B;
    }
    .history_featurebox{
        float: right;
        font-size: 0;
    }
    .history_featureitem{
        font-size: 14px;
        display: inline-block;
        position: relative;
        margin-left:15px;
        padding-left: 40px;
        max-width: 200px;
        vertical-align:middle;
    }
    .history_featureitem::before{
        content:'';
        position: absolute;
        left:0px;
        top:-8px;
        width: 37px;
        height: 37px;
        border-radius: 50%;
        background: #FF6849;
    }
    .history_cont{
        width: 100%;
        position: relative;
    }
    // .history_line{
    //     width: 4px;
    //     height: 100%;
    //     background: #AD4532;
    // }
    .history_cont::before{
        position: absolute;
        content:'';
        width: 4px;
        height: 100%;
        background: #AD4532;
        left:calc(50% - 2px);
        top:0;
    }
    .history_left,.history_right{
        width: calc(50% - 2px);
    }
    // .history_right{
    //     margin-left: 2px;
    // }
    .history_onebox{
        position: relative;
        background: #AD4532;
    }
    .history_oneimg{
        width: 100%;
        display: block;
    }
    .history_one,.history_two{
        width: 100%;
        display: flex;
    }
    .history_onetxt{
       position: absolute;
       width: 400px;
       height: 194px;
       top:0;
       right:0;
       bottom:0;
       left:0;
       margin:auto;
       font-size: 80px;
       font-weight: bold;
       color:#FFD9B7;
    }
    .history_twoimg{
        width: 502px;
        margin-left:auto;
        margin-top: 86px;
        display: block;
    }
    .history_twoimgs{
        width: 560px;
        display: block;
        margin:258px 0 0  auto;
    }
    .history_twobox{
        padding:86px 50px 50px;
        box-sizing: border-box;
    }
    .history_twotxt{
        width: 100%;
        font-size: 30px;
        line-height: 70px;
    }
    .history_rightimg{
        width: 465px;
        display: block;
        margin:60px 0 70px;
    }
    .history_twotxt.center{
        margin-bottom: 70px;
    }
    .history_health.history_onetxt{
        width:561px;
        left:50px;
        right:auto;
    }
    .history_threeimg{
        width: 538px;
        display: block;
        margin:208px 0 0 auto;
    }
    .history_threebox{
        padding:40px 50px;
        box-sizing: border-box;
    }
    .history_threerimg{
        width: 479px;
        display: block;
        margin:60px 0;
    }
    .history_threecimg{
        width: 1115px;
        position: relative;
        z-index: 10;
        margin:46px 0 47px -610px;
    }
    .history_oneline.history_onetxt{
        height: 109px;
        width: 550px;
        left:50px;
        right:auto;
    }
    .history_fourimg1{
        display: block;
        width: 566px;
        margin:206px 0 470px auto;
    }
    .history_fourimg2{
        display: block;
        width: 566px;
        margin-bottom: 950px;
        margin-left: auto;
    }
    .history_fourimg3{
        display: block;
        width: 599px;
        margin-left: auto;
    }
    .history_twotxt.mtb{
        margin: 65px 0 50px;
    }
    .history_fourimg4{
        width: 547px;
        display: block;
        margin-right: auto;
        margin-bottom: 58px;
    }
     .history_fiveimg3{
        width: 575px;
        margin:1300px 0 0 auto;
        display: block;
     }
     .history_fiveimg1{
        display: inline-block;
        width: 519px;
     }
     .history_fiveimg2{
        width: 548px;
        display: inline-block;
     }
     .history_fiveimgbox{
        position: relative;
        width: 1067px;
        margin: 43px 0 63px -566px
     }
     .fivebt{
        margin:68px 0 90px;
     }
     .history_siximg3{
        display: block;
        width: 552px;
        margin:54px 0 0 auto;
     }
     .history_siximg1{
          display: block;
          width: 832px;
          margin:10px 0 29px -462px;
     }
     .history_sixbox{
        box-sizing: border-box;
        padding:120px 50px;
     }
     .history_world{
        width: 100%;
        height: 340px;
        line-height: 340px;
        text-align: center;
        font-size: 80px;
        font-weight: bold;
        color:#FFD9B7;
        background: #AD4532;
        margin-bottom: 22px;
     }
     @media screen and (max-width: 1510px) {
        .history_featuretit::after{
            width: 180px;
            margin-right: 50px;
            bottom:-54px;
        }
        .history_featureitem{
            max-width: 100px;
        }
        .history_featureitem:nth-child(1),
        .history_featureitem:nth-child(2), 
        .history_featureitem:nth-child(3),
        .history_featureitem:nth-child(7){
          padding-top: 10px;
        }
        .history_featureitem:nth-child(1)::before,
        .history_featureitem:nth-child(2)::before,
        .history_featureitem:nth-child(3)::before,
        .history_featureitem:nth-child(7)::before{
            top:6px;
        }
     }
     @media screen and (max-width: 1330px) {
        .history_featureitem::before{
            width: 25px;
            height: 25px;
            top: -2px;
        }
        .history_featureitem{
            padding-left: 30px;
        }
        .history_featureitem:nth-child(1),
        .history_featureitem:nth-child(2), 
        .history_featureitem:nth-child(3),
        .history_featureitem:nth-child(7){
          padding-top: 10px;
        }
        .history_featureitem:nth-child(1)::before,
        .history_featureitem:nth-child(2)::before,
        .history_featureitem:nth-child(3)::before,
        .history_featureitem:nth-child(7)::before{
            top:12px;
        }
        .history_featuretit{
            font-size: 25px;
            padding-top: 10px;
        }
        .history_featuretit::after{
            width: 150px;
            height: 4px;
            bottom:-49px;
            margin-right: 50px;
        }
      
     }
     @media screen and (max-width: 1250px) {
        .config{
         width: 90%;
        }
        .history_onetxt{
            font-size: 60px;
            height: 160px;
        }
        .history_health.history_onetxt{
            width: calc(100% - 50px);
        }
     }
     @media screen and (max-width: 1230px) {
        .history_feature{
            padding-left:10px;
        }
        .history_featuretit{
            text-align: right;
            padding-top: 0;
            float: none;
            margin-right: 0;
            display: block;
            margin-bottom: 40px;
        }
        .history_featuretit::after{
            bottom:-30px;
            left:auto;
            right:0;
            margin-right: 0;
        }
        .history_featurebox{
            float: none;
            display: block;
            text-align: right;
        }
        .history_featureitem{
            padding-left:0;
            padding-right: 28px;
        }
        .history_featureitem::before{
            left:auto;
            right:0;
        }
        .history_twoimg{
            width: 80%;
        }
        .history_twoimgs{
            width: 90%;
        }
        .history_twobox{
            padding:70px 50px 50px;
        }
        // .history_twobox{
        //     padding:60px 40px 40px;
        // }
        // .history_sixbox{
        //     padding:120px 40px;
        // }
        .history_rightimg{
            width: 80%;
        }
        .history_twotxt{
            font-size: 25px;
            line-height: 55px;
        }
        .history_threeimg{
            width: 90%;
        }
        .history_threerimg{
            width: 80%;
            margin:45px 0;
        }
        .history_fourimg1,.history_fourimg2{
            width: 90%;
        }
        .history_fourimg4{
            width: 100%;
        }
        .history_fourimg3{
            width: 92%;
        }
        .history_fiveimg3{
            width: 90%;
        }
        .history_siximg3{
            width: 90%;
        }
        .history_siximg1{
            margin:0 0 29px -462px;
        }
     }
     @media screen and (max-width: 1150px) {

        .history_tit{
            font-size: 70px;
        }
     }
     @media screen and (max-width: 768px) {
        .mobile{
            display: block;
        }
        .pc{
            display: none;
        }
          .configm_headlogo{
             width:120px;
             top:25px;
          }
          .configm_language.mobile {
             margin-right: 10px;
             display: inline-block;
          }
          .configm_head{
             padding-left: 20px;
             height: 70px;
          }
         .configm_languagemember{
             top:25px;
             right:20px;
         }

         .configm_footleft img{
             margin:0 0 10px;
         }
         .configm_footleft{
             float: none;
         }
         .configm_footertop{
             padding:0 15px 10px;
         }
         .configm_footrigth{
             float: none;
             text-align: left;
             width:100%;
         }
         .configm_footrtext{
             margin-top: 10px;
             margin-bottom: 0;
             font-size: 14px;
         }
         .configm_footerbot{
             font-size: 14px;
             padding:15px;
         }
         .configm_footerbotl{
             float: none;
             margin-bottom: 10px;
         }
         .configm_footerbotr{
             float: none;
         }
        //  内容
        .history_tit{
            font-size: 34px;
            margin-bottom: 10px;
        }
        .history_top{
            padding:30px 15px;
        }
        .history_titen{
            height: auto;
            width: 90%;
            font-size: 20px;
            margin-bottom: 10px;
        }
        .history_titdes{
            font-size: 16px;
            line-height: 30px;
        }
        .history_feature{
            margin-top: 20px;
        }
        .history_featureitem{
            max-width:100%;
            padding-right: 15px;
            margin-bottom: 10px;
            padding-top: 0!important;
        }
        .history_featureitem::before{
            width:12px;
            height: 12px;
            top:3px!important;
        }
        .history_featuretit{
            margin-bottom: 30px;
        }
        .history_featuretit::after{
            bottom:-15px;
            width: 120px;
            height: 3px;
        }
        .history_onetxt{
            width: 80%;
            height: 80px;
            font-size: 26px;
        }
        .history_twobox{
            padding:30px 15px;
        }
        .history_twotxt{
            font-size: 14px;
            line-height: 28px;
        }
        .history_rightimg{
            margin:10px 0 15px;
        }
        .history_twotxt.center{
            margin-bottom: 15px;
        }
        .history_health.history_onetxt{
            width: calc(100% - 15px);
            left:15px;
        }
        .history_threebox{
            padding:20px 15px;
        }
        .history_threerimg{
            margin:15px 0;
        }
        .history_threecimg{
            width: 376px;
            margin:30px 0 20px -200px;
        }
        .history_oneline.history_onetxt{
            width: calc(100% - 15px);
            height: 35px;
            left:15px;
        }
        .history_twotxt.mtb{
            margin:20px 0 15px;
        }
        .history_fourimg4{
            margin-bottom: 20px;
        }
        .history_fiveimgbox{
            margin:10px 0 10px -180px;

        }
        .history_fiveimg1{
            width: auto;
            height: 140px;
        }
        .history_fiveimg2{
            width: auto;
            height: 140px;
        }
        .fivebt{
            margin:20px 0 15px;
        }
        .history_sixbox{
            padding:30px 15px;
        }
        .history_siximg1{
            width: 200%;
            margin:0 0  10px -109%;
        }
        .history_world{
            font-size: 30px;
            height: 120px;
            line-height: 120px;
            margin-bottom: 10px;
        }
        .history_twoimgs{
            margin-top: 400px;
        }
        .history_fiveimg3{
            margin-top: 1000px;
        }
     }
   </style>